import React from "react";

// Page numbers shown on each side of the current page. First and last page are
// always rendered, so the widest possible row is 1 … c-1 c c+1 … N — seven
// buttons no matter how large totalPages grows.
const SIBLINGS = 1;

function pageItems(currentPage, totalPages) {
  // Small enough to render every page with no gaps.
  if (totalPages <= SIBLINGS * 2 + 5) {
    return [...Array(totalPages)].map((_, idx) => idx + 1);
  }

  const start = Math.max(2, currentPage - SIBLINGS);
  const end = Math.min(totalPages - 1, currentPage + SIBLINGS);

  const items = [1];
  if (start > 2) items.push("start-ellipsis");
  for (let page = start; page <= end; page += 1) items.push(page);
  if (end < totalPages - 1) items.push("end-ellipsis");
  items.push(totalPages);

  return items;
}

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const buttonBase =
    "px-3 py-1.5 text-sm rounded-lg border shrink-0 disabled:opacity-40 disabled:cursor-not-allowed";
  const buttonIdle =
    "border-gray-200 bg-white text-gray-600 hover:bg-gray-50";

  return (
    <div className="flex flex-wrap justify-end items-center mt-4 gap-2">
      <span className="text-sm text-gray-500 mr-1 whitespace-nowrap">
        Page {currentPage} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        className={`${buttonBase} ${buttonIdle}`}
      >
        Prev
      </button>
      {pageItems(currentPage, totalPages).map((item) =>
        typeof item === "string" ? (
          <span
            key={item}
            aria-hidden="true"
            className="px-1 text-sm text-gray-400 select-none shrink-0"
          >
            …
          </span>
        ) : (
          <button
            key={item}
            onClick={() => onPageChange(item)}
            aria-current={currentPage === item ? "page" : undefined}
            className={`${buttonBase} ${
              currentPage === item
                ? "bg-gray-900 text-white border-gray-900"
                : buttonIdle
            }`}
          >
            {item}
          </button>
        )
      )}
      <button
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        className={`${buttonBase} ${buttonIdle}`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
